import React from "react"
import { connectInfiniteHits } from "react-instantsearch-dom"
import { ClearCurrentDemosearchRefinements } from "components/page-components/Ausschreibungsdienste/demosearch/search-components"
import { DemosearchTenderHit } from "components/page-components/Ausschreibungsdienste/demosearch/hit-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import { validate_invitation_code } from "components/page-components/Ausschreibungsdienste/utils"

import { Link } from "gatsby"

export const DemosearchInfiniteHits = connectInfiniteHits(
  ({
    hits,
    hasMore,
    refineNext,
    autocomplete_input_value,
    set_autocomplete_input_value,
    service_refinement_state,
    set_service_refinement_state,
    set_geosearch_lat_lng,
    set_geosearch_around_radius,
    set_geosearch_input_value,
    geosearch_lat_lng,
    geosearch_around_radius,
  }) => {
    const { image } = useStaticQuery(graphql`
      query {
        image: file(
          relativePath: { eq: "illustrations/general/no-result.png" }
        ) {
          childImageSharp {
            gatsbyImageData(
              width: 550
              formats: [AUTO, AVIF]
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
      }
    `)
    return (
      <React.Fragment>
        {!!hits?.[0] ? (
          <div className="ais-InfiniteHits">
            <ul className="ais-InfiniteHits-list">
              {hits.map((hit, index) => (
                <DemosearchTenderHit
                  {...{
                    hit,
                    no_flex: true,
                    key: `demosearch-infinity-hit-${index}`,
                  }}
                />
              ))}
            </ul>
          </div>
        ) : validate_invitation_code(autocomplete_input_value) ? (
          <div className="has-text-centered my-6">
            <p className="has-text-mitternachtsblau mx-6 mt-6 mb-4">
              Sie haben einen Einladungscode für ein beschränktes
              Vergabeverfahren eingegeben. <br /> Mit dem Code können Sie
              Fristen, Unterlagen und Mitteilungen des Auftraggebers einsehen.
            </p>
            <Link
              to={`/ausschreibungsdienste/teilnehmen/beschraenkte?einladung=${autocomplete_input_value}`}
              className="button is-sonnengelb"
            >
              Zum Verfahren
            </Link>
          </div>
        ) : (
          <div className="is-flex is-flex-direction-column">
            <GatsbyImage
              image={image.childImageSharp.gatsbyImageData}
              alt="Keine Ergebnisse"
              className="mx-auto"
            />
            <p className="has-text-mitternachtsblau my-4 mx-auto">
              Wir konnten leider keine Suchergebnisse finden.
            </p>
            <ClearCurrentDemosearchRefinements
              {...{
                clearsQuery: true,
                autocomplete_input_value,
                set_autocomplete_input_value,
                service_refinement_state,
                set_service_refinement_state,
                set_geosearch_lat_lng,
                set_geosearch_around_radius,
                geosearch_lat_lng,
                geosearch_around_radius,
                set_geosearch_input_value,
              }}
            />
          </div>
        )}
        {hasMore ? (
          <div className="has-text-centered">
            <button className="button is-mitternachtsblau" onClick={refineNext}>
              Mehr laden...
            </button>
          </div>
        ) : null}
      </React.Fragment>
    )
  }
)
